import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5010/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Dataset APIs
export const uploadDataset = async (file, name) => {
  const formData = new FormData();
  formData.append('file', file);
  if (name) formData.append('name', name);

  const response = await api.post('/datasets', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const getDatasets = async () => {
  const response = await api.get('/datasets');
  return response.data;
};

export const getDataset = async (id) => {
  const response = await api.get(`/datasets/${id}`);
  return response.data;
};

export const getDatasetPreview = async (id, limit = 100) => {
  const response = await api.get(`/datasets/${id}/preview?limit=${limit}`);
  return response.data;
};

export const deleteDataset = async (id) => {
  const response = await api.delete(`/datasets/${id}`);
  return response.data;
};

// Forecast APIs
export const createForecast = async (datasetId, predictionType, parameters = {}) => {
  const response = await api.post('/forecasts', {
    datasetId,
    predictionType,
    parameters,
  });
  return response.data;
};

export const getForecasts = async (filters = {}) => {
  const params = new URLSearchParams(filters);
  const response = await api.get(`/forecasts?${params}`);
  return response.data;
};

export const getForecast = async (id) => {
  const response = await api.get(`/forecasts/${id}`);
  return response.data;
};

export const deleteForecast = async (id) => {
  const response = await api.delete(`/forecasts/${id}`);
  return response.data;
};

export const exportForecastReport = async (id) => {
  const response = await api.get(`/forecasts/${id}/export`);
  return response.data;
};

// Alert APIs
export const getAlerts = async (filters = {}) => {
  const params = new URLSearchParams(filters);
  const response = await api.get(`/alerts?${params}`);
  return response.data;
};

export const acknowledgeAlert = async (id) => {
  const response = await api.put(`/alerts/${id}/acknowledge`);
  return response.data;
};

export const resolveAlert = async (id) => {
  const response = await api.put(`/alerts/${id}/resolve`);
  return response.data;
};

export const dismissAlert = async (id) => {
  const response = await api.put(`/alerts/${id}/dismiss`);
  return response.data;
};

// Dashboard API
export const getDashboardSummary = async () => {
  const response = await api.get('/dashboard/summary');
  return response.data;
};

// Health check
export const healthCheck = async () => {
  const response = await api.get('/health');
  return response.data;
};

export default api;
